const Event = {
    DOCUMENT_SAVED: 'document:saved',
    DOCUMENT_SAVE_FAILED: 'document:savefailed',
    /**
     * This event is emitted when the document has changed using normal editing.
     */
    DOCUMENT_CHANGED: 'document:changed',
    /**
     * This event is emitted when the document has changed on server and the changes has been successfully
     * transferred to the document in browser.
     */
    DOCUMENT_CHANGED_EXTERNAL: 'document:changed:external',
    DOCUMENT_REPLACING: 'document:replacing',
    DOCUMENT_REPLACED: 'document:replaced',
    DOCUMENT_INVALIDATED: 'document:invalidated',
    DIALOG_CLOSE: 'dialog:close',
    NOTIFICATION_ADD: 'notification:add',
    HISTORY_SAVED: 'history:saved',
    HISTORY_CLEARED: 'history:cleared',
    USERACTION_SAVE: 'useraction:save',
    USERACTION_LOCK: 'useraction:lock',
    USERACTION_UNLOCK: 'useraction:unlock',
    USERACTION_KEY_ESCAPE: 'useraction:keypressed_esc',
    USERACTION_KEY_ENTER: 'useraction:keypressed_enter',
    USERACTION_CANCEL_SAVE: 'useraction:cancel_save',
    DISABLE_UNLOAD_WARNING: 'unload:disable_warning',
    ENABLE_UNLOAD_WARNING: 'unload:enable_warning',
    BROWSER_RESIZE: 'browser:resize',
    SETTINGS_CHANGED: 'settings:changed',
    TWITTER_READY: 'twitter:ready',
    FACEBOOK_READY: 'facebook:ready',
    ARTICLELANGUAGE_CHANGED: 'articlelanguage:changed'
}

export {Event}

export default Event
